/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { store as coreStore } from '@wordpress/core-data';
import { withSelect, withDispatch } from '@wordpress/data';
import apiFetch from '@wordpress/api-fetch';
import { PanelBody } from '@wordpress/components';
import { compose } from '@wordpress/compose';

/**
 * Exteranl dependencies.
 */
import { has, last, merge, isArray } from 'lodash';

/**
 * Inner dependencies.
 */
import GutenifyFontFamilyControl from '../components/FontFamilyControl/index.js';
import { getParsedVar } from '../settings/utils';
import styling from '../settings/inline-css';

const ColorPalette = ( { getSiteOptions, globalStyles, updateSiteOptions } ) => {
	const siteOptions = getSiteOptions();

	let textFontFamily = has( globalStyles, `styles.typography.fontFamily` ) ? getParsedVar( globalStyles.styles.typography.fontFamily ) : '';
	if ( has( siteOptions, `settings.styles.typography.fontFamilySlug` ) ) {
		textFontFamily = siteOptions.settings.styles.typography.fontFamilySlug;
	}
	const textFontFamilySlug = isArray( textFontFamily ) ? last( textFontFamily ) : textFontFamily;

	let headingsFontFamily = '';
	if ( has( siteOptions, `settings.styles.elements.headings.typography.fontFamilySlug` ) ) {
		headingsFontFamily = siteOptions.settings.styles.elements.headings.typography.fontFamilySlug;
	}
	const headingsFontFamilySlug = isArray( headingsFontFamily ) ? last( headingsFontFamily ) : headingsFontFamily;

	// console.log( textFontFamily, textFontFamilySlug );
	let gutenifyStyles = {};

	if ( has( siteOptions, 'settings.styles' ) ) {
		gutenifyStyles = siteOptions.settings.styles;
	}

	const setGutenifyStyles = ( data ) => {
		const options = {
			...siteOptions,
			settings: {
				...siteOptions.settings,
				styles: merge( gutenifyStyles, data ),
			},
		};
		updateSiteOptions( options );
	};

	// console.log( getSiteOptions );

	const saveSiteOptions = () => {
		const newSiteOptions = getSiteOptions();
		const settings = newSiteOptions?.settings;
		apiFetch( {
			path: `/gutenify/v1/update_site_options`,
			method: 'POST',
			data: {
				styles: { ...settings.styles },
			},
		} )
			.then( ( res ) => {
				console.log( res );
			} )
			.catch( ( err ) => {
				// console.log( err );
			} );

		const coreStyles = newSiteOptions.coreSettings.styles;
		const gutenifyCustomStyles = newSiteOptions.settings.styles;

		const css = styling( coreStyles, gutenifyStyles );
		const adminCss = styling( coreStyles, gutenifyCustomStyles, true );
		apiFetch( {
			path: `/gutenify/v1/update_global_styles`,
			method: 'POST',
			data: {
				css,
				adminCss,
			},
		} )
			.then( ( res ) => {

			} )
			.catch( ( err ) => {
				console.log( err );
			} );
	};

	return (
		<>
			<PanelBody title={ __( 'Typography' ) } >
				<div className="gutenify-field-wrapper gutenify-field-grid">
					<div className="gutenify-field-label">
						<label htmlFor="text-color-control">{ __( 'Text' ) }</label>
					</div>
					<div className="gutenify-field-control">
						<GutenifyFontFamilyControl
							label=""
							value={ textFontFamilySlug }
							onChange={ ( fontFamilySlug ) => {
								// console.log( fontFamilySlug );
								const data = merge( gutenifyStyles, {
									typography: {
										fontFamilySlug,
									},
								} );
								setGutenifyStyles( { ...data } );
								saveSiteOptions();
							} }
						/>

					</div>
				</div>
				<div className="gutenify-field-wrapper gutenify-field-grid">
					<div className="gutenify-field-label">
						<label htmlFor="text-color-control">{ __( 'Heading' ) }</label>
					</div>
					<div className="gutenify-field-control">
						<GutenifyFontFamilyControl
							label=""
							value={ headingsFontFamilySlug }
							onChange={ ( fontFamilySlug ) => {
								// console.log( fontFamilySlug );
								const data = merge( gutenifyStyles, {
									elements: {
										headings: {
											typography: {
												fontFamilySlug,
											},
										},
									},
								} );
								setGutenifyStyles( { ...data } );
								saveSiteOptions();
							} }
						/>

					</div>
				</div>
			</PanelBody>
		</>
	);
};

const ColorPaletteCompose = compose( withSelect( ( select ) => {
	const { getSettings, getSiteOptions } = select( 'gutenify/settings' );
	const siteOptions = getSiteOptions();
	const coreSelect = select( coreStore );
	return {
		styleId: coreSelect.__experimentalGetCurrentGlobalStylesId(),
		globalStyles: coreSelect.__experimentalGetCurrentThemeBaseGlobalStyles(),
		settings: getSettings(),
		siteOptions,
		getSiteOptions,
	};
} ),
withDispatch( ( dispatch ) => {
	const { setSettings, updateSiteOptions } = dispatch( 'gutenify/settings' );
	return {
		setSettings,
		updateSiteOptions,
	};
} ) )( ColorPalette );

addFilter( 'gutenify--global-options--sidebar', 'gutenify--global-options--sidebar--color-palette', ( content ) => {
	return [
		...content,
		<div key="gutenify--global-options--sidebar--color-palette">
			<ColorPaletteCompose />
		</div>,
	];
}
);
